import { QuestionnaireService } from "./questionnaire.service";

export const questionnaireService = new QuestionnaireService();
